import { render, staticRenderFns } from "./sentdetail.vue?vue&type=template&id=434309b9&"
import script from "./sentdetail.vue?vue&type=script&lang=js&"
export * from "./sentdetail.vue?vue&type=script&lang=js&"
import style0 from "./sentdetail.vue?vue&type=style&index=0&id=434309b9&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports